









import { Component, Vue } from 'vue-property-decorator'
import { investText } from '@/views/analys/analyChart/coms/pageBottomText'
import PageButtomText from '@/components/pageBottomText/index.vue'
import PageSection from './coms/index.vue'
import ThreeSection from './coms/groupThree/index.vue'

@Component({
  name: 'printInvest',
  components: {
    PageSection,
    ThreeSection,
    PageButtomText
  }
})

export default class extends Vue {
  investText = investText
}
